import * as requestFromServer from "./crud";
import {QNASlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = QNASlice;

export const fetchQNAList = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const _filter = convertFilter(queryParams);

  return requestFromServer
    .getQNAByFilter(_filter)
    .then(response => {
      const {pageInfo: {totalCnt}, csList} = response;
      dispatch(actions.QNAListFetched({totalCnt, csList}));
    })
    .catch(error => {
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchQNA = qnaId => dispatch => {
  if (!qnaId) {
    return dispatch(actions.QNAFetched({qna: undefined}));
  }
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getQNAById(qnaId)
    .then(response => {
      const qna = response;
      dispatch(actions.QNAFetched({qna}));
    })
    .catch(error => {
      console.log(error);
      error.clientMessage = "Can't find link";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

